// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";

export interface FeaturedCategoriesApiParameter extends ApiParameter {
    categoriesIds?: string[];
}

const categoriesUrl = "/api/sc/categories/get";

export function loadFeaturedCategoriesApiParameter(parameter: FeaturedCategoriesApiParameter) {
    if (!parameter || !parameter.categoriesIds) {
        return [];
    }

    let selectedCategories = "";
    parameter.categoriesIds.forEach(id => {
        selectedCategories += `SelectedCategories=${id}&`;
    });
    selectedCategories = selectedCategories.slice(0, -1);

    const result = get<any>(`${categoriesUrl}?${selectedCategories}`);
    return result;
}

